import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const STATUS = {
  in_attesa: ["🕐", "#facc15"], invio: ["⏳", "#38bdf8"],
  inviata: ["✅", "#39ff14"], errore: ["❌", "#fb7185"], annullata: ["🚫", "#94a3b8"],
};
const hhmm = (iso) => new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });

export default function ScheduledToday() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.get("/emails/scheduled").then((r) => {
      const today = new Date().toDateString();
      setRows((r.data || []).filter((x) => x.status !== "annullata" && new Date(x.scheduled_at).toDateString() === today));
    }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!rows.length) return null;
  const pending = rows.filter((r) => r.status === "in_attesa" || r.status === "invio").length;
  return (
    <div className="panel" style={{ marginTop: 8 }} data-testid="scheduled-today-panel">
      <div className="today-head">📤 Email programmate di oggi <span className="nav-badge">{rows.length}</span>{pending > 0 && <span className="muted" style={{ fontSize: 12, fontWeight: 400 }}> · {pending} in partenza</span>}</div>
      <ul className="today-list">
        {rows.map((r) => {
          const [ico, col] = STATUS[r.status] || ["•", "#94a3b8"];
          return (
            <li key={r.id} data-testid={`sched-today-${r.id}`}>
              <span style={{ color: col }}>{ico}</span> <strong>{hhmm(r.scheduled_at)}</strong> · {r.to}
              <span className="muted"> · {r.subject || "(senza oggetto)"}</span>
              {r.status === "errore" && <span style={{ color: "#fb7185", fontSize: 12 }}> — invio fallito</span>}
              {r.status === "inviata" && <span style={{ color: "#39ff14", fontSize: 12 }}> — inviata</span>}
            </li>
          );
        })}
      </ul>
      <Link className="today-link" to="/inviate">Gestisci le programmate →</Link>
    </div>
  );
}
